import { calcSalary } from './calcSalary';

export const calcTotalSalary = (orders, payment) => {
	
	return orders?.reduce(
		(current, next) =>
			current +
			calcSalary(next, payment),
		0,
	);
};
